<div class="periodTime" *ngIf="display">
    <span class="periodTime-time" *ngIf="timeRemaining">
        <i class="periodTime-time-icon fas fa-stopwatch"></i>
        <ng-container *ngIf="daysRemaining > 0">
            {{daysRemaining}}
            <ng-container *ngIf="daysRemaining == 1"[i18nKey]="'common.day'"></ng-container>
            <ng-container *ngIf="daysRemaining > 1"[i18nKey]="'common.days'"></ng-container> <span [i18nKey]="'common.and'"></span>
        </ng-container>
        {{timeRemaining}}
    </span>
    <span class="periodTime-label"[i18nKey]="'header.period.time.remaining.time.before.period.end'"></span>
</div>
